import React, { useEffect, useRef, useState, useCallback } from "react";
import Container from "../../../../layouts/containers/Container";
import InvoiceTreatment from "./components/InvoiceTreatment";
import baseUrl from "../../../../api/baseUrl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import InvoicePatient from "./components/InvoicePatient";
import Amount from "./components/Amount";
import Pays from "./components/Pays";
import { toast } from "react-toastify";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import { useDispatch } from "react-redux";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PrintIcon from "@mui/icons-material/Print";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
import Printtest from "../../setting/printtest/Printtest";
import TabBar from "../../../../components/tabbar/TabBar";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import {
  setPrintaction,
  setPrintAmount,
  setPrintclinic,
  setPrintPatient,
  setPrintSubTreatment,
  setPrintTreatment,
} from "../../../../redux/printstate/printActions";
import PaymentTr from "./components/PaymentTr";
import ReportModal from "../../manage/alltreatments/addtreatment/treatmenttable/components/reportModal/ReportModal";
interface FormData {
  treatmentId: string;
  patientId: string | null;
  userName: string;
  regno: string;
  paymentid: string;
  age: number;
  total: number;
  lastDue: number;
  payable: number;
  discount: number;
  netotal: number;
  due: number;
  card: number;
  cash: number;
  bankTransfer: number;
}

const Invoice: React.FC = () => {
  const [addTreatmentOpent, setAddTreatmentOpent] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const [pays, setPays] = useState(false);
  const [edit, setEdit] = useState(false);
  const [treatment, setTreatment] = useState<any[]>([]);
  const [payment, setPayment] = useState<any[]>([]);
  const { ID } = useParams<{ ID: string }>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState<FormData>({
    treatmentId: ID || "",
    patientId: "",
    userName: "",
    regno: "",
    paymentid: "",
    age: 0,
    total: 0,
    lastDue: 0,
    payable: 0,
    discount: 0,
    netotal: 0,
    due: 0,
    card: 0,
    cash: 0,
    bankTransfer: 0,
  });

  const printRef = useRef<HTMLDivElement>(null);
  const [printData, setPrintData] = useState("");
  const [doctorId, setDoctorId] = useState("");

  const fetchData = useCallback(async () => {
    if (ID) {
      dispatch(setloadeActive());
      try {
        const treatmentResponse = await baseUrl.get(
          "treatment/find-treatment",
          {
            headers: { treatmentid: ID },
          }
        );
        const birthdateDate = new Date(
          treatmentResponse.data.data.patientId.dob ?? new Date()
        );

        setDoctorId(
          treatmentResponse?.data?.data?.doctorId?._id
            ? treatmentResponse?.data?.data?.doctorId?._id
            : treatmentResponse?.data?.data?.createdBy
        );

        const currentDate = new Date();
        const ageDiff = currentDate.getFullYear() - birthdateDate.getFullYear();
        const isBirthdayPassed =
          currentDate.getMonth() < birthdateDate.getMonth() ||
          (currentDate.getMonth() === birthdateDate.getMonth() &&
            currentDate.getDate() < birthdateDate.getDate());

        setTreatment(treatmentResponse.data.data?.treatment || []);
        const treatmentData = treatmentResponse.data.data;

        let totals = 0;

        treatmentResponse.data.data.treatment.forEach((item: any) => {
          if (!item.paid && item.status !== "planned") {
            totals += parseFloat(item.price);
          }

          item?.subTreatment?.forEach((items: any) => {
            if (
              items.selected_option === "treatment_paid" &&
              !items.paid &&
              items.status !== "planned"
            ) {
              totals += parseFloat(items.price);
            }
          });
        });

        const paymentResponse = await baseUrl.get("payment/last-payment", {
          headers: { treatmentid: ID },
        });

        dispatch(setloadeDeactive());
        setPayment(paymentResponse.data.data);

        let dues = 0;
        paymentResponse.data.data.forEach((item: any) => {
          dues +=
            parseFloat(item.total) -
            parseFloat(item.discount) -
            parseFloat(item.card) -
            parseFloat(item.bankTransfer) -
            parseFloat(item.cash);
        });

        setFormData((prevFormData) => ({
          ...prevFormData,
          total: totals,
          regno: treatmentData.patientId.regNo,
          userName: treatmentData.patientId.fullName,
          treatmentId: treatmentData?._id,
          patientId: treatmentData?.patientId._id,
          age: ageDiff - (isBirthdayPassed ? 1 : 0),
          lastDue: dues,
          payable: dues + totals,
          netotal: dues + totals,
          due: dues + totals,
        }));
      } catch (error) {
        dispatch(setloadeDeactive());
        console.error(error);
      }
    }
  }, [ID, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (!ID) {
      setTreatment([]);
      setPayment([]);

      setFormData((prevFormData) => ({
        ...prevFormData,
        treatmentId: ID || "",
        patientId: "",
        userName: "",
        age: 0,
        regno: "",
        total: 0,
        lastDue: 0,
        payable: 0,
        discount: 0,
        netotal: 0,
        due: 0,
        card: 0,
        cash: 0,
        bankTransfer: 0,
      }));
    }
  }, [location, ID]);

  const addToTreatment = useCallback((e: any) => {
    if (ID) {
      fetchData();
    } else {
      let totals = 0;
      e.forEach((item: any) => {
        totals += parseFloat(item.prices) * parseFloat(item.quantity);
        item?.subTreatment?.forEach((items: any) => {
          if (items.selected_option === "treatment_paid") {
            totals += parseFloat(items.price);
          }
        });
      });

      setFormData((prevFormData) => ({
        ...prevFormData,
        total: totals,
        payable: totals,
        netotal: totals,
      }));
    }
  }, []);

  const handleSave = useCallback(
    (e: any) => {
      dispatch(setloadeActive());
      if (!edit) {
        if (ID) {
          baseUrl
            .post("payment/addPayment", {
              ...formData,
              ...(doctorId ? { doctorId } : {}),
              sms: e,
            })
            .then(() => {
              dispatch(setloadeDeactive());
              setFormData({
                ...formData,
                card: 0,
                cash: 0,
                bankTransfer: 0,
                discount: 0,
              });
              setPays(false);
              setEdit(false);
              fetchData();
            })
            .catch((error) => {
              dispatch(setloadeDeactive());
            });
        } else {
          if (formData.patientId !== "") {
            baseUrl
              .post("treatment/create-paymenttreatments", {
                patientId: formData.patientId,
                treatment,
                formData,
                ...(doctorId ? { doctorId } : {}),
                sms: e,
              })
              .then((response) => {
                dispatch(setloadeDeactive());
                setFormData({
                  ...formData,
                  card: 0,
                  cash: 0,
                  discount: 0,
                  bankTransfer: 0,
                });
                setPays(false);
                setEdit(false);
                fetchData();

                navigate(`/client/payments/invoice/${response.data.data.treatmentId}`);
              })
              .catch((error) => {
                dispatch(setloadeDeactive());
              });
          } else {
            toast("select Patient");
          }
        }
      } else {
        baseUrl
          .patch(
            "payment/editPayment",
            {
              ...formData,
            },
            {
              headers: {
                paymentid: formData?.paymentid,
              },
            }
          )
          .then((response) => {
            dispatch(setloadeDeactive());
            setFormData({
              ...formData,
              card: 0,
              cash: 0,
              discount: 0,
              bankTransfer: 0,
            });
            setPays(false);
            fetchData();
            setEdit(false);

            navigate(`/client/payment/invoice/${response.data.data.treatmentId}`);
          })
          .catch((error) => {
            dispatch(setloadeDeactive());
          });
      }
    },
    [ID, formData, treatment, dispatch, navigate]
  );

  const handlePays = useCallback(() => {
    if (formData.patientId !== "") {
      if (treatment.length > 0) {
        setPays(true);
        setEdit(false);
      } else {
        toast("select Treatment");
      }
    } else {
      toast("select Patient");
    }
  }, [formData.patientId, treatment]);

  const handleEdit = useCallback((e: any) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      netotal: parseInt(e?.netotal),
      payable: parseInt(e?.netotal) + parseInt(e?.discount),
      due: e?.due,
      paymentid: e?._id,
      discount: e?.discount,
      card: e?.card,
      cash: e?.cash,
      bankTransfer: e?.bankTransfer,
    }));
    setPays(true);
    setEdit(true);
  }, []);

  const removeDiagnosis = useCallback(
    (e: any) => {
      if (ID) {
        baseUrl
          .post(
            "treatment/remove-treatments",
            {},
            { headers: { treatmentid: ID, treatmentsid: e } }
          )
          .then(async () => {
            const updatedItems = treatment.filter((item) => item?._id !== e);
            setTreatment(updatedItems);
            let totals = 0;
            updatedItems?.forEach((item: any) => {
              if (!item?.paid && item.status !== "planned") {
                totals += parseFloat(item.price) * parseFloat(item.quantity);
              }

              item?.subTreatment?.forEach((items: any) => {
                if (
                  items.selected_option === "treatment_paid" &&
                  !items.paid &&
                  items.status !== "planned"
                ) {
                  totals += parseFloat(items.price);
                }
              });
            });

            const paymentResponse = await baseUrl.get("payment/last-payment", {
              headers: { treatmentid: ID },
            });

            dispatch(setloadeDeactive());
            setPayment(paymentResponse.data.data);

            let dues = 0;
            paymentResponse.data.data.forEach((item: any) => {
              dues +=
                parseFloat(item.total) -
                parseFloat(item.discount) -
                parseFloat(item.card) -
                parseFloat(item.bankTransfer) -
                parseFloat(item.cash);
            });

            setFormData((prevFormData) => ({
              ...prevFormData,
              total: totals,
              lastDue: dues,
              payable: dues + totals,
              netotal: dues + totals,
              due: dues + totals,
            }));
          })
          .catch((error) => console.log(error));
      } else {
        const updatedItems = treatment.filter(
          (item) => item?.treatmentkey !== e
        );
        setTreatment(updatedItems);
        let totals = 0;
        updatedItems.forEach((item: any) => {
          totals += parseFloat(item.price) * parseFloat(item.quantity);
          item?.subTreatment?.forEach((items: any) => {
            if (items.selected_option === "treatment_paid") {
              totals += parseFloat(items.price);
            }
          });
        });

        setFormData((prevFormData) => ({
          ...prevFormData,
          total: totals,
          payable: totals,
          netotal: totals,
        }));
      }
    },
    [ID, treatment, formData]
  );
  const removeSubTreatment = useCallback(
    (e: any) => {
      if (ID) {
        baseUrl
          .patch("/client/treatments/subTreatment/delete-subtreetment", {
            maintreatmentid: ID,
            treatmentid: e.treatment_id,
            subtreatmentid: e.sub_treatment_id,
          })

          .then(async () => {
            const updatedItems = treatment.map((item) => {
              if (item._id === e?.treatment_id) {
                return {
                  ...item,
                  subTreatment: item.subTreatment.filter(
                    (subItem: any) => subItem._id !== e?.sub_treatment_id
                  ),
                };
              }
              return item;
            });
            setTreatment(updatedItems);
            let totals = 0;

            updatedItems.forEach((item: any) => {
              if (!item?.paid && item.status !== "planned") {
                totals += parseFloat(item.price) * parseFloat(item.quantity);
              }

              item?.subTreatment?.forEach((items: any) => {
                if (
                  items.selected_option === "treatment_paid" &&
                  !items.paid &&
                  items.status !== "planned"
                ) {
                  totals += parseFloat(items.price);
                }
              });
            });

            const paymentResponse = await baseUrl.get("payment/last-payment", {
              headers: { treatmentid: ID },
            });

            dispatch(setloadeDeactive());
            setPayment(paymentResponse.data.data);

            let dues = 0;
            paymentResponse.data.data.forEach((item: any) => {
              dues +=
                parseFloat(item.total) -
                parseFloat(item.discount) -
                parseFloat(item.card) -
                parseFloat(item.bankTransfer) -
                parseFloat(item.cash);
            });

            setFormData((prevFormData) => ({
              ...prevFormData,
              total: totals,
              lastDue: dues,
              payable: dues + totals,
              netotal: dues + totals,
              due: dues + totals,
            }));
          })
          .catch((error) => console.log(error));
      } else {
        const updatedItems = treatment.filter(
          (item) => item?.treatmentkey !== e
        );
        setTreatment(updatedItems);
        let totals = 0;
        updatedItems.forEach((item: any) => {
          totals += parseFloat(item.prices) * parseFloat(item.quantity);
        });

        setFormData((prevFormData) => ({
          ...prevFormData,
          total: totals,
          payable: totals,
          netotal: totals,
        }));
      }
    },
    [ID, treatment, formData]
  );

  useEffect(() => {
    if (printData) {
      handlePrinting();
    }
  }, [printData]);

  const dispatchPrintActions = useCallback(
    (e: any) => {
      e?.amounts?.clinicId?.bills?.forEach((element: any) => {
        const { title, top, left, show, size } = element;
        if (top)
          dispatch(setPrintaction({ name: title, target: "top", value: top }));
        if (left)
          dispatch(
            setPrintaction({ name: title, target: "left", value: left })
          );
        if (show !== undefined)
          dispatch(
            setPrintaction({ name: title, target: "show", value: show })
          );
        if (size)
          dispatch(
            setPrintaction({ name: title, target: "size", value: size })
          );
      });
      dispatch(
        setPrintclinic({
          clinicName: e?.amounts?.clinicId?.title,
          tpNo: e?.amounts?.clinicId?.tpNo,
          address: e?.amounts?.clinicId?.address,
          drName:
            "Dr " +
            e?.amounts?.doctorId?.firstName +
            " " +
            e?.amounts?.doctorId?.lastName,
          printImages: e?.amounts?.clinicId?.printImages,
        })
      );

      dispatch(
        setPrintPatient({
          invoiceNo: e?.amounts?.invoiceNo,
          invoiceDate: e?.amounts?.updatedAt,
          regNo: e?.patientData?.regNo,
          fullName: e?.patientData?.fullName,
          mobileNo: e?.patientData?.mobileNo,
          gender: e?.patientData?.gender,
          dob: e?.patientData?.dob,
        })
      );
      dispatch(
        setPrintAmount({
          total: e?.amounts?.total,
          lastDue: e?.amounts?.lastDue,
          discount: e?.amounts?.discount,
          netotal: e?.amounts?.netotal,
          card: e?.amounts?.card,
          cash: e?.amounts?.cash,
          bankTransfer: e?.amounts?.bankTransfer,
        })
      );
      dispatch(setPrintTreatment(e?.treatmentdata));
      dispatch(setPrintSubTreatment(e?.subPayments));
    },
    [dispatch]
  );

  const handlePrint = useCallback(async (e: any) => {
    try {
      const response = await baseUrl.get("payment/getPaymentById", {
        headers: { paymentid: e?.paymentid },
      });
      setPrintData(response.data);
      console.log(response.data);
      
      dispatchPrintActions(response.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handlePrinting = async () => {
    if (printRef.current) {
      printRef.current.style.display = "block";
      const element = printRef.current;
      const options = {
        scale: 2, // Improve quality
        useCORS: true, // Allow cross-origin images
        allowTaint: true,
      };

      const canvas = await html2canvas(element, options);
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 210; // A4 width in mm
      const imgProps = canvas.width / canvas.height;
      const imgHeight = imgWidth / imgProps; // Auto height based on aspect ratio

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [imgWidth, imgHeight], // Dynamic height
      });

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight, "", "FAST");

      const pdfBlob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Create an iframe and append to document
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.top = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      printRef.current.style.transform = "none";
      document.body.appendChild(iframe);
      iframe.src = blobUrl;

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          printRef.current!.style.display = "none";
        }, 500);
      };
    } else {
      console.error("Content ref is not defined");
    }
  };

  const handleSms = useCallback(async (e: any) => {
    try {
      await baseUrl.get("payment/smsinvoice", {
        headers: { paymentid: e?._id, patientid: e?.patientId },
      });
      toast("sms sent");
    } catch (error) {
      console.error("Error sending SMS:", error);
    }
  }, []);

  const openTreatment = useCallback(() => {
    if (ID || doctorId !== "") {
      setAddTreatmentOpent(true);
    } else {
      toast("select doctor");
    }
  }, [ID, doctorId]);
  const closePay = useCallback(() => {
    fetchData();
    setPays(false);
  }, []);

  const generatePaymentReport = useCallback(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("/client/report/invoiceReport", {
        // .get("/client/report/patientInvoiceReport", {
        responseType: "blob",
        headers: { treatmentid: ID },
      })
      .then((response) => {
        if (response.status === 204) {
          toast("No data found");
          return;
        }
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = "downloaded.pdf";
        document.body.appendChild(link);

        link.click();

        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [dispatch]);

  return (
    <>
        <div>
          <Container>
            <div className="space-y-3 md:space-y-3">
              <InvoicePatient
                formData={formData}
                setdoctorid={setDoctorId}
                doctorid={doctorId}
                setformData={setFormData}
              />

              {/* Treatment Table Section */}
              <div className="bg-white rounded-xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
                <div className="px-4 py-3 md:px-6 md:py-4 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0">
                  <h3 className="text-base sm:text-lg font-bold text-slate-800">Treatment & Consultation Charges</h3>
                  <button
                    onClick={openTreatment}
                    className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white text-sm font-medium hover:shadow-lg hover:shadow-primary/20 transition-all w-full sm:w-auto"
                  >
                    + ADD
                  </button>
                </div>

                {/* Mobile Card View */}
                <div className="block md:hidden divide-y divide-slate-100">
                  {treatment?.map((item, i) => (
                    <React.Fragment key={item._id ?? i}>
                      {item?.status !== "planned" && (
                        <div className="p-4 bg-white hover:bg-slate-50 transition-colors">
                          <div className="flex items-start justify-between gap-3 mb-3">
                            <div className="flex-1 min-w-0">
                              <h4 className="text-sm font-semibold text-slate-900 mb-1 truncate">{item.treatment}</h4>
                              <div className="flex flex-wrap gap-2 text-xs text-slate-600">
                                <span className="bg-slate-100 px-2 py-0.5 rounded">{item.type}</span>
                                {item.subtype && <span className="bg-slate-100 px-2 py-0.5 rounded">{item.subtype}</span>}
                                {item.toothNo && <span className="bg-slate-100 px-2 py-0.5 rounded">Tooth: {item.toothNo}</span>}
                              </div>
                            </div>
                            {!item?.paid && (
                              <button
                                onClick={() => removeDiagnosis(item._id ?? item.treatmentkey)}
                                className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-100 transition-colors"
                                aria-label="Delete treatment"
                              >
                                <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                              </button>
                            )}
                          </div>
                          <div className="grid grid-cols-2 gap-3 text-sm">
                            <div>
                              <span className="text-slate-500 text-xs">Date</span>
                              <p className="text-slate-700 font-medium">{item?._id ? item?.createdAt?.split("T")[0] : new Date(item?.createdAt).toLocaleDateString()}</p>
                            </div>
                            <div>
                              <span className="text-slate-500 text-xs">Qty</span>
                              <p className="text-slate-700 font-medium">{item.quantity}</p>
                            </div>
                            <div className="col-span-2">
                              <span className="text-slate-500 text-xs">Price</span>
                              <p className="text-emerald-600 font-bold text-lg">{item.price}</p>
                            </div>
                            {item.note && (
                              <div className="col-span-2">
                                <span className="text-slate-500 text-xs">Note</span>
                                <p className="text-slate-600 text-sm">{item.note}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {item?.subTreatment?.map((items: any) => {
                        if ((items?.selected_option === "treatment_paid" || items?.selected_option === "treatment_non_paid") && items?.status !== "planned") {
                          return (
                            <div key={`${item._id}-${items._id}`} className="p-4 bg-slate-50/50 hover:bg-slate-100/50 transition-colors pl-8">
                              <div className="flex items-start justify-between gap-3 mb-3">
                                <div className="flex-1 min-w-0">
                                  <h4 className="text-sm font-medium text-slate-700 mb-1 truncate">{items.treatment || "N/A"}</h4>
                                  <div className="flex flex-wrap gap-2 text-xs text-slate-600">
                                    {items.type && <span className="bg-slate-100 px-2 py-0.5 rounded">{items.type}</span>}
                                    {items.subtype && <span className="bg-slate-100 px-2 py-0.5 rounded">{items.subtype}</span>}
                                    {items.toothNo && <span className="bg-slate-100 px-2 py-0.5 rounded">Tooth: {items.toothNo}</span>}
                                  </div>
                                </div>
                                {!items?.paid && (
                                  <button
                                    onClick={() => removeSubTreatment({ treatment_id: item._id, sub_treatment_id: items._id })}
                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-100 transition-colors"
                                    aria-label="Delete sub treatment"
                                  >
                                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                                  </button>
                                )}
                              </div>
                              <div className="grid grid-cols-2 gap-3 text-sm">
                                <div>
                                  <span className="text-slate-500 text-xs">Date</span>
                                  <p className="text-slate-700 font-medium">{items?._id ? items?.createdAt?.split("T")[0] : new Date(items?.createdAt).toLocaleDateString()}</p>
                                </div>
                                <div>
                                  <span className="text-slate-500 text-xs">Qty</span>
                                  <p className="text-slate-700 font-medium">{items.quantity || "N/A"}</p>
                                </div>
                                <div className="col-span-2">
                                  <span className="text-slate-500 text-xs">Price</span>
                                  <p className="text-emerald-600 font-bold text-lg">{items.price || 0}</p>
                                </div>
                                {items.note && (
                                  <div className="col-span-2">
                                    <span className="text-slate-500 text-xs">Note</span>
                                    <p className="text-slate-600 text-sm">{items.note}</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </React.Fragment>
                  ))}
                  {treatment?.length === 0 && (
                    <div className="p-8 text-center text-slate-500">
                      <p className="text-sm">No treatments added yet</p>
                    </div>
                  )}
                </div>

                {/* Desktop Table View */}
                <div className="hidden md:block">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Treatment</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Type</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider hidden lg:table-cell">Sub Type</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider hidden xl:table-cell">Tooth No</th>
                        <th className="px-4 py-3 text-center text-xs font-bold text-slate-700 uppercase tracking-wider">Qty</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider">Price</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider hidden lg:table-cell">Note</th>
                        <th className="px-4 py-3 text-center text-xs font-bold text-slate-700 uppercase tracking-wider w-20">Action</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-100">
                      {treatment?.map((item, i) => (
                        <React.Fragment key={item._id ?? i}>
                          {item?.status !== "planned" && (
                            <tr className="hover:bg-slate-50/50 transition-colors group">
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600">
                                {item?._id ? item?.createdAt?.split("T")[0] : new Date(item?.createdAt).toLocaleDateString()}
                              </td>
                              <td className="px-4 py-3 text-sm font-semibold text-slate-900">
                                {item.treatment}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600">
                                <span className="bg-slate-100 px-2 py-1 rounded-md text-xs">{item.type}</span>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 hidden lg:table-cell">
                                {item.subtype && <span className="bg-slate-100 px-2 py-1 rounded-md text-xs">{item.subtype}</span>}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 hidden xl:table-cell">
                                {item.toothNo}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 text-center font-medium">{item.quantity}</td>
                              <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-emerald-600 text-right">{item.price}</td>
                              <td className="px-4 py-3 text-sm text-slate-500 hidden lg:table-cell max-w-[200px]">
                                <div className="truncate">{item.note || "-"}</div>
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-center">
                                {!item?.paid && (
                                  <button
                                    onClick={() => removeDiagnosis(item._id ?? item.treatmentkey)}
                                    className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 active:bg-red-200 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 opacity-0 group-hover:opacity-100"
                                    aria-label="Delete treatment"
                                  >
                                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                                  </button>
                                )}
                              </td>
                            </tr>
                          )}

                          {item?.subTreatment?.map((items: any) => {
                            if ((items?.selected_option === "treatment_paid" || items?.selected_option === "treatment_non_paid") && items?.status !== "planned") {
                              return (
                                <tr key={`${item._id}-${items._id}`} className="hover:bg-slate-50/50 transition-colors bg-slate-50/30 group">
                                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 pl-8">
                                    {items?._id ? items?.createdAt?.split("T")[0] : new Date(items?.createdAt).toLocaleDateString()}
                                  </td>
                                  <td className="px-4 py-3 text-sm text-slate-700 italic">
                                    └ {items.treatment || "N/A"}
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600">
                                    {items.type && <span className="bg-slate-100 px-2 py-1 rounded-md text-xs">{items.type}</span>}
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 hidden lg:table-cell">
                                    {items.subtype && <span className="bg-slate-100 px-2 py-1 rounded-md text-xs">{items.subtype}</span>}
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 hidden xl:table-cell">
                                    {items.toothNo || "N/A"}
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 text-center font-medium">{items.quantity || "N/A"}</td>
                                  <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-emerald-600 text-right">{items.price || 0}</td>
                                  <td className="px-4 py-3 text-sm text-slate-500 hidden lg:table-cell max-w-[200px]">
                                    <div className="truncate">{items.note || "-"}</div>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap text-center">
                                    {!items?.paid && (
                                      <button
                                        onClick={() => removeSubTreatment({ treatment_id: item._id, sub_treatment_id: items._id })}
                                        className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 active:bg-red-200 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 opacity-0 group-hover:opacity-100"
                                        aria-label="Delete sub treatment"
                                      >
                                        <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                            return null;
                          })}
                        </React.Fragment>
                      ))}
                    </tbody>
                    <Amount formData={formData} />
                  </table>
                </div>
              </div>

              {/* Invoices Section */}
              <div className="bg-white rounded-xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
                <div className="px-4 py-3 md:px-6 md:py-4 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0">
                  <h3 className="text-base sm:text-lg font-bold text-slate-800">Invoices</h3>
                  <button
                    onClick={handlePays}
                    className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white text-sm font-medium hover:shadow-lg hover:shadow-primary/20 transition-all w-full sm:w-auto"
                  >
                    PAY
                  </button>
                </div>

                {/* Mobile Card View */}
                <div className="block md:hidden divide-y divide-slate-100">
                  {payment.map((item, i) => {
                    const isEditable = payment?.length - 1 === i;
                    return (
                      <div key={i} className="p-4 bg-white hover:bg-slate-50 transition-colors">
                        <div className="flex items-start justify-between gap-3 mb-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-2">
                              <h4 className="text-sm font-bold text-indigo-600">#{item?.invoiceNo}</h4>
                              {isEditable && (
                                <span className="bg-amber-100 text-amber-700 text-xs px-2 py-0.5 rounded-full font-medium">Editable</span>
                              )}
                            </div>
                            <p className="text-xs text-slate-500">{item?.createdAt?.split("T")[0]}</p>
                          </div>
                          <div className="flex gap-1.5 flex-shrink-0">
                            <button
                              onClick={() => handlePrint({ paymentid: item?._id, invoiceno: item?.invoiceNo })}
                              className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-100 transition-colors"
                              title="Print"
                            >
                              <PrintIcon sx={{ fontSize: 18 }} />
                            </button>
                            <button
                              onClick={() => handleSms(item)}
                              className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-100 transition-colors"
                              title="Send SMS"
                            >
                              <SendIcon sx={{ fontSize: 18 }} />
                            </button>
                            {isEditable && (
                              <button
                                onClick={() => handleEdit(item)}
                                className="w-8 h-8 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center hover:bg-amber-100 transition-colors"
                                title="Edit"
                              >
                                <EditIcon sx={{ fontSize: 18 }} />
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div>
                            <span className="text-slate-500 text-xs">Total</span>
                            <p className="text-slate-800 font-bold text-base">{parseInt(item?.netotal) + parseInt(item?.discount)}</p>
                          </div>
                          <div>
                            <span className="text-slate-500 text-xs">Discount</span>
                            <p className="text-orange-600 font-semibold">{item?.discount}</p>
                          </div>
                          <div>
                            <span className="text-slate-500 text-xs">Cash</span>
                            <p className="text-emerald-600 font-semibold">{item?.cash}</p>
                          </div>
                          <div>
                            <span className="text-slate-500 text-xs">Card</span>
                            <p className="text-indigo-600 font-semibold">{item?.card}</p>
                          </div>
                          <div className="col-span-2">
                            <span className="text-slate-500 text-xs">Bank Transfer</span>
                            <p className="text-sky-600 font-semibold">{item?.bankTransfer}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {payment.length === 0 && (
                    <div className="p-8 text-center text-slate-500">
                      <p className="text-sm">No invoices yet</p>
                    </div>
                  )}
                </div>

                {/* Desktop Table View */}
                <div className="hidden md:block">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">Invoice No</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider">Total</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider">Discount</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider">Cash</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider hidden lg:table-cell">Card</th>
                        <th className="px-4 py-3 text-right text-xs font-bold text-slate-700 uppercase tracking-wider hidden lg:table-cell">Transfer</th>
                        <th className="px-4 py-3 text-center text-xs font-bold text-slate-700 uppercase tracking-wider w-32">Action</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-100">
                      {payment.map((item, i) => (
                        <PaymentTr
                          item={item}
                          key={i}
                          handlePrint={handlePrint}
                          handleSms={handleSms}
                          handleEdit={handleEdit}
                          editable={payment?.length - 1 === i}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Report Buttons */}
              {ID && (
                <div className="flex flex-col sm:flex-row flex-wrap gap-2">
                  <button
                    onClick={() => setReportOpen(true)}
                    className="px-4 sm:px-6 py-2 sm:py-2.5 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white text-xs sm:text-sm font-medium hover:shadow-lg hover:shadow-primary/20 transition-all w-full sm:w-auto"
                  >
                    General Report
                  </button>
                  <button
                    onClick={generatePaymentReport}
                    className="px-4 sm:px-6 py-2 sm:py-2.5 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white text-xs sm:text-sm font-medium hover:shadow-lg hover:shadow-primary/20 transition-all w-full sm:w-auto"
                  >
                    Payment Report
                  </button>
                </div>
              )}
            </div>

            {addTreatmentOpent && (
              <InvoiceTreatment
                treatment={treatment}
                setaddTreatmentOpent={setAddTreatmentOpent}
                settreatment={setTreatment}
                addToTreatment={addToTreatment}
                doctorid={doctorId}
              />
            )}
            {pays && (
              <Pays
                handleSave={handleSave}
                closePay={closePay}
                formData={formData}
                setformData={setFormData}
                edit={edit}
              />
            )}
          </Container>
          {reportOpen && <ReportModal setReportOpen={setReportOpen} />}
        </div>
      <div style={{ position: "absolute", left: "-9999px" }}>
        <div ref={printRef} style={{ display: "none" }}>
          <Printtest />
        </div>
      </div>
    </>
  );
};

export default Invoice;
